import { Add } from "@mui/icons-material";
import { Button, Dropdown, IconButton, Menu, MenuButton, MenuItem } from "@mui/joy";

import { MenuItemLink } from "@/components/Links";
import { useModal } from "@/components/modals/useModal";
import { useCurrentRouteMatch } from "@/hooks/useCurrentRouteMatch";
import { useCurrentVenueQuery } from "@/hooks/venues";

const AddNewButton = ({
  isExpanded,
  size = "lg",
}: {
  isExpanded: boolean;
  size?: "sm" | "md" | "lg";
}) => {
  const venue = useCurrentVenueQuery().data;
  const currentRoute = useCurrentRouteMatch();

  const { display: displayModal } = useModal();

  return (
    <Dropdown>
      <MenuButton
        slots={{ root: isExpanded ? Button : IconButton }}
        slotProps={{
          root: {
            size,
            ...(isExpanded
              ? {
                  startDecorator: <Add />,
                }
              : {
                  color: "primary",
                  variant: "solid",
                }),
            sx: {
              margin: 1,
              whiteSpace: "nowrap",
            },
          },
        }}
      >
        {isExpanded ? "Add new" : <Add />}
        <Menu placement="top">
          <MenuItemLink
            to="/gym/$venueUuid/routes/$climbType/create"
            params={{
              venueUuid: (currentRoute.params as { venueUuid: string }).venueUuid,
              climbType:
                (currentRoute.params as { climbType?: string }).climbType ||
                venue?.climbTypes[0] ||
                "BOULDER",
            }}
          >
            Route...
          </MenuItemLink>
          <MenuItem onClick={() => displayModal("CREATE_TASK")}>Task...</MenuItem>
          <MenuItemLink
            to="/gym/$venueUuid/schedule/calendar"
            params={{
              venueUuid: (currentRoute.params as { venueUuid: string }).venueUuid,
            }}
            search={{
              createSet: true,
            }}
          >
            Set...
          </MenuItemLink>
          <MenuItemLink
            to="/gym/$venueUuid/events/create"
            params={{
              venueUuid: (currentRoute.params as { venueUuid: string }).venueUuid,
            }}
          >
            Event...
          </MenuItemLink>
        </Menu>
      </MenuButton>
    </Dropdown>
  );
};

export default AddNewButton;
